import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import I18n from '../i18n';
import useDebounceCallback from '../../hooks/use-debounce-callback';

const DEBOUNCE_DELAY = 300;

export default function SearchInput(props) {
  const {onChange, className, initialValue, ...rest} = props;
  const [searchTerm, setSearchTerm] = React.useState(initialValue);
  const triggerChange = useDebounceCallback(DEBOUNCE_DELAY, onChange);

  const onSearchTermChange = React.useCallback(changeEvent => {
    setSearchTerm(changeEvent.target.value);
    triggerChange(changeEvent.target.value);
  });

  const onClear = React.useCallback(() => {
    setSearchTerm('');
    triggerChange('');
  });

  return (
    <div className={classnames('search-input', className)} {...rest}>
      <input
        type="search"
        placeholder={I18n.t('action.search')}
        className="form-control"
        value={searchTerm}
        onChange={onSearchTermChange}
      />
      <span
        className="fa fa-times clear"
        style={{visibility: searchTerm && searchTerm.length ? 'visible' : 'hidden'}}
        onClick={onClear}
      />
    </div>
  );
}

SearchInput.defaultProps = {};

SearchInput.propTypes = {
  /** A callback to execute when the search input changes. Will be passed the input value */
  onChange: PropTypes.func,
  /** An optional className to add to the HTML element. */
  className: PropTypes.string,
  /** The initial search value. */
  initialValue: PropTypes.string,
};
